import axios from "axios";

export async function getCNPJ(cnpj) {
    try {
      return await consultarCNPJ(cnpj, token);
    } catch(err) {

      return err;
    }
}

async function consultarCNPJ(cnpj) {
  if (!cnpj) throw new Error("CNPJ não informado");

  cnpj = cnpj.replace(/[^0-9]/g, "");

  return new Promise((resolve, reject) => {
    let url = process.env.URL_CONSULTA_API + "/v1/companies?api_key=" + process.env.API_KEY_CONSULTA_API + "&cnpj=" + cnpj;

    axios({
      method: "get",
      url,
    })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response.data);
      });
  });
}
